import { render, staticRenderFns } from "./DashboardShow.vue?vue&type=template&id=1e277b4a"
import script from "./DashboardShow.vue?vue&type=script&lang=js"
export * from "./DashboardShow.vue?vue&type=script&lang=js"
import style0 from "./DashboardShow.vue?vue&type=style&index=0&id=1e277b4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports